import React, { useEffect, useState } from "react";
import { IoCloseCircleOutline } from "react-icons/io5";
import { FaDownload } from "react-icons/fa";
import { IoTriangle } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { formatDate, formatTime, colors, notify, status, getExtencionImg } from "utils";
import TripMap from "components/TripMap";
import { FaClock, FaUser, FaTruck, FaMapMarker } from "react-icons/fa";
import { TbProgressHelp } from "react-icons/tb";
import {
  getDestailsTrip,
  getDestinationsTrip,
  getRoutesByTrip,
} from "actions/Monitoring";
import { format } from "date-fns";
import { ModalAnswers } from "./ModalAnswers";
import Loader from "../../UI/Loader";
import Carousel from "../Carousel";
const URL_BUCKET = process.env.REACT_APP_BUCKET_BASE_URL ?? "";

const ModalHeader = ({ title, onClose }) => (
  <div className="h-20 w-full flex flex-row justify-between items-center px-5 bg-black rounded-t-lg">
    <span className="text-white font-[Gravity] text-2xl font-bold">
      {title}
    </span>
    <IoCloseCircleOutline
      onClick={onClose}
      className="text-white text-4xl cursor-pointer"
    />
  </div>
);

const ModalBody = ({ data, t, getRouteFromApi, showExtraInfo }) => {
  const [activeTab, setActiveTab] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [destinations, setDestinations] = useState([]);
  const [details, setDetails] = useState([]);
  const [tripSelected, setTripSelected] = useState(0);
  const [detailSelected, setDetailSelected] = useState(null);
  const [indexSelected, setIndexSelected] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [routes, setRoutes] = useState([]);

  useEffect(() => {
    if (getRouteFromApi) {
      getRoutesPath(data.id);
    } else {
      setRoutes(data.route ?? []);
    }
    getDestinations(data.id);
  }, [data, getRouteFromApi]);

  const getLastPosition = () => {
    if (routes.length === 0) return {};
    const { latitude, longitude } = routes[routes.length - 1];
    return { lat: latitude, lng: longitude };
  };

  const getPaths = () => {
    if (!routes) return [];
    if (routes.length === 0) return [];
    return routes.map((item) => {
      const { latitude, longitude } = item;
      return { lat: latitude, lng: longitude };
    });
  };

  const getDestinations = async (idTrip) => {
    setIsLoading(true);
    try {
      const response = await getDestinationsTrip(idTrip);
      if (response.length > 0) {
        setDestinations(response);
      } else {
        notify("warning", "No hay detalles para este viaje", 6000);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getRoutesPath = async (idTrip) => {
    setIsLoading(true);
    try {
      const response = await getRoutesByTrip(idTrip);
      if (response?.length > 0) {
        setRoutes(response);
      } else {
        setRoutes([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const transformData = (data) => {
    return data.flatMap(
      (item) =>
        item.polls?.map((poll) => ({
          parentDescription: item.name,
          poll,
        })) || []
    );
  };

  const getDetails = async (idTrip) => {
    setTripSelected(idTrip);
    setIsLoading(true);
    try {
      const response = await getDestailsTrip(idTrip);
      if (response?.length > 0) {
        setActiveTab(0);
        setDetails(transformData(response));
      } else {
        setDetails([]);
      }
    } finally {
      setDetailSelected(null);
      setIsLoading(false);
    }
  };

  const downloadImage = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = url.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="pt-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm border-b-2 pb-4">
        <div>
          <strong>{t("detailModal.idTrip")} : </strong> {data.id}
        </div>
        {data.operator && (
          <div className="flex gap-1 items-center">
            <FaUser />
            <strong>{t("detailModal.operator")} : </strong>{" "}
            {data.operator?.user?.name ?? ""}{" "}
            {data.operator?.user?.lastName ?? ""}{" "}
            {data.operator?.user?.secondLastName ?? ""}
          </div>
        )}
        {data.unidad && (
          <div className="flex gap-1 items-center">
            <FaTruck />
            <strong>{t("detailModal.unit")} : </strong>
            {data.unidad.plateNumber}
          </div>
        )}
        <div className="flex gap-1 items-center">
          <TbProgressHelp className="text-lg" />
          <strong>{t("detailModal.status")} : </strong>
          <span
            className={`${
              colors[data.status] ?? "bg-blue-gray-300"
            } text-sm ml-4 font-semibold rounded-xl px-4 py-1 border border-yellow-700 shadow-inner`}
          >
            {status(t)[data.status] ?? "Sin Estatus"}
          </span>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm border-b-2 pb-4">
        <div className="flex gap-1 items-center">
          <FaClock /> <strong>{t("detailModal.startTime")} : </strong>{" "}
          {formatTime(data.createdAt)}
        </div>
        <div className="flex gap-1 items-center">
          <FaClock />
          <strong>{t("detailModal.travelDate")} : </strong>{" "}
          {formatDate(data.createdAt)}
        </div>
        <div className="flex gap-1 items-center">
          <FaClock />
          <strong>{t("detailModal.endHour")} : </strong>
          {formatTime(data.endTrip)}
        </div>
        <div>
          <strong>{t("detailModal.scheduledAppointments")} : </strong>
          {data.destination.length > 0
            ? data.destination.filter((item) => item.type === "destino").length
            : 0}
        </div>
        <div className="flex gap-1 items-center">
          <FaClock />
          <strong>{t("detailModal.actualTime")} : </strong>{" "}
          {formatTime(data.startTrip)}
        </div>
        <div className="flex gap-1 items-center">
          <FaClock />
          <strong>{t("detailModal.actualEndTime")} : </strong>{" "}
          {formatTime(data.endTrip)}
        </div>
        <div className="flex gap-1 items-center">
          <FaClock />
          <strong>{t("detailModal.completedAppointments")} : </strong>{" "}
          {data.destination.filter((item) => item.status === "Finished").length}
        </div>
        {showExtraInfo && (
          <>
            <div className="flex gap-1 items-center">
              <FaTruck />
              <strong>Tipo de unidad : </strong> {data.truck.name}
            </div>
            <div className="flex gap-1 items-center">
              <FaTruck />
              <strong>Unidad : </strong> {data.truck.plateNumber}
            </div>
            <div className="flex gap-1 items-center">
              <FaMapMarker />
              <strong>Origen : </strong>{" "}
              {(() => {
                const findOrigin = data.destination.find(
                  (item) => item.type === "origen"
                );
                return findOrigin ? findOrigin.shPt : "No disponible";
              })()}
            </div>
            <div className="flex gap-1 items-center">
              <FaClock />
              <strong>Fecha real inicio : </strong>{" "}
              {(() => {
                const date = data.startTrip;
                if (!date) return "No disponible";
                return format(new Date(date), "yyyy-MM-dd HH:mm:ss");
              })()}
            </div>
             <div className="flex gap-1 items-center">
              <FaClock />
              <strong>Fecha real termino : </strong>{" "}
              {(() => {
                const date = data.endTrip;
                if (!date) return "No disponible";
                return format(new Date(date), "yyyy-MM-dd HH:mm:ss");
              })()}
            </div>
          </>
        )}
      </div>

      <Carousel
        tripSelected={tripSelected}
        destinations={destinations}
        getDetails={getDetails}
      />

      <div className="flex gap-4 border-b">
        <button
          className={`${
            activeTab === 0 ? "text-black border-black" : "text-gray-400"
          }  font-semibold border-b-2  pb-2 hover:scale-105 transition-transform`}
          onClick={() => {
            if (details.length === 0) return null;
            setActiveTab(0);
          }}
        >
          {t("detailModal.surveysAndIncidents")}
        </button>
        <button
          className={`${
            activeTab === 1 ? "text-black border-black" : "text-gray-400"
          }  font-semibold border-b-2  pb-2 hover:scale-105 transition-transform`}
          onClick={() => setActiveTab(1)}
        >
          {t("detailModal.map")}
        </button>
      </div>

      {isLoading ? (
        <Loader type="truck" />
      ) : (
        activeTab === 0 && (
          <div className="grid grid-cols-12 mt-4 gap-4">
            <div className="col-span-12 md:col-span-4 flex flex-col gap-2 overflow-y-auto h-[450px] pt-4 pl-4">
              {details.map((item, i) => (
                <div key={i} className="flex items-center gap-4">
                  <span
                    className={`w-3 h-3 rounded-full ${
                      item.poll.isIncident ? "bg-yellow-500" : "bg-green-500"
                    }`}
                  ></span>
                  <div
                    onClick={() => {
                      setDetailSelected(item);
                      setIndexSelected(i);
                    }}
                    key={i}
                    className={`w-[90%] ${
                      i === indexSelected ? "bg-gray-400" : ""
                    } border rounded-lg p-2 shadow-sm hover:cursor-pointer hover:scale-105 transition-transform hover:border-black`}
                  >
                    <div className="flex items-center gap-2">
                      <div className="text-black">
                        <span className="text-xs">
                          {format(
                            new Date(item.poll.date),
                            "yyyy-MM-dd HH:mm:ss"
                          )}
                        </span>
                        <div className="flex text-sm font-semibold gap-10">
                          <span># {item.poll.id}</span>
                          <span>{item.poll.name}</span>
                        </div>
                        <div className="text-xs">{item.parentDescription}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {detailSelected && (
              <div className="col-span-12 md:col-span-8">
                <div className="border rounded-md p-4 h-[65%] overflow-y-auto">
                  {detailSelected.poll.questions.map((item, index) => (
                    <div key={index} className="pb-8 space-y-5">
                      <label className="p-3 bg-gray-400 font-semibold rounded-lg">
                        {index + 1}.- {item.name} : {item.isVideo ? "" : item.response}
                      </label>
                      {item.signedUrl || item.responseFile ? (
                        <>
                          <div className="flex items-center justify-between bg-yellow-200 px-4 py-2 rounded-t-md">
                            <div className="flex justify-center font-semibold text-sm">
                              <IoTriangle className="rotate-180 mr-2 mt-1" />
                              {t("detailModal.captureEvidence")}
                            </div>
                          </div>
                          <div className="flex gap-4 mt-4">
                            <div className="flex flex-col items-center gap-2">
                              {(() => {
                                // Si hay signedUrl, usarla directamente
                                if (item.signedUrl) {
                                  return item.isVideo ? (
                                    <video
                                      controls
                                      controlsList="nodownload"
                                      preload="metadata"
                                      className="rounded-lg object-cover bg-black shadow-lg"
                                      style={{ width: '360px', height: '640px' }}
                                      src={item.signedUrl}
                                    />
                                  ) : (
                                    <img
                                      className="w-80 h-60 rounded-lg object-contain bg-black"
                                      src={item.signedUrl}
                                      alt={`Evidencia ${index + 1}`}
                                    />
                                  );
                                }

                                // Fallback: si no hay signedUrl, usar responseFile
                                const mediaUrl = item.responseFile || item.response;
                                
                                // Construir URL completa
                                const fullUrl = mediaUrl.startsWith('http') 
                                  ? mediaUrl 
                                  : `${URL_BUCKET}${mediaUrl.startsWith('/') ? mediaUrl : `/${mediaUrl}`}`;

                                // Si es video (basado en prop isVideo)
                                if (item.isVideo) {
                                  return (
                                    <video
                                      controls
                                      controlsList="nodownload"
                                      preload="metadata"
                                      className="rounded-lg object-cover bg-black shadow-lg"
                                      style={{ width: '360px', height: '640px' }}
                                      src={fullUrl}
                                    />
                                  );
                                }

                                // Para imágenes, validar extensión
                                const fileExtension = getExtencionImg(mediaUrl);
                                const isImage = ["jpg", "png", "jpeg"].includes(fileExtension);

                                return isImage ? (
                                  <img
                                    className="w-24 h-20 bg-cover"
                                    src={fullUrl}
                                    alt={`Evidencia ${index + 1}`}
                                  />
                                ) : null;
                              })()}
                              <button
                                className="bg-blue-300 p-1 rounded-lg hover:scale-105 transition-transform"
                                onClick={() => {
                                  // Usar signedUrl si existe, sino construir la URL
                                  if (item.signedUrl) {
                                    downloadImage(item.signedUrl);
                                    return;
                                  }
                                  
                                  const mediaUrl = item.responseFile || item.response;
                                  const fullUrl = mediaUrl.startsWith('http') 
                                    ? mediaUrl 
                                    : `${URL_BUCKET}${mediaUrl.startsWith('/') ? mediaUrl : `/${mediaUrl}`}`;
                                  downloadImage(fullUrl);
                                }}
                              >
                                <FaDownload className="w-4 h-4 text-white" />
                              </button>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="w-40 flex items-center justify-between bg-gray-500 px-4 py-2 rounded-t-md">
                          <div className="flex justify-center font-semibold text-sm">
                            <IoTriangle className="rotate-90 mr-2 mt-1" />
                            {t("detailModal.noNEvidence")}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )
      )}
      {activeTab === 1 && isLoading === false && (
        <div className="h-[450px] w-full ">
          <TripMap lastLocation={getLastPosition()} paths={getPaths()} />
        </div>
      )}
      {isModalOpen && (
        <ModalAnswers
          setIsModalOpen={setIsModalOpen}
          data={detailSelected?.poll.questions ?? []}
        />
      )}
    </div>
  );
};

const ModalDetailTrip = ({
  isOpen,
  onClose,
  data,
  getRouteFromApi = false,
  showExtraInfo = false,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [t] = useTranslation("monitoring");

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setShowModal(true), 10);
    } else {
      setShowModal(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div
        className={`bg-white overflow-auto rounded-xl shadow-lg  w-[90vw] h-[90vh] relative transition-all duration-300 transform ${
          showModal ? "scale-100 opacity-100" : "scale-95 opacity-0"
        }`}
      >
        <ModalHeader title={t("detailModal.tripDetail")} onClose={onClose} />
        <div className="lg:px-10 sm:px-0">
          <ModalBody
            data={data}
            t={t}
            getRouteFromApi={getRouteFromApi}
            showExtraInfo={showExtraInfo}
          />
        </div>
      </div>
    </div>
  );
};

export default ModalDetailTrip;
